<template>
  <container :class="['page-wrapper']">
    <flex :spacing="3">
      <flex-col :span="24">
        <test-toolbar />
      </flex-col>
      <flex-col :span="24">
        <form-schema title-color="white" :validators="validators" :rounded="rounded" :title-bg-color="$root.colors.primary" :title-bg-color-lightness="$root.colors.bgColorLightness" :title="$lang.myJsonSchemaForm" :label-color="$dark ? 'white' : 'black'" :color="$root.colors.primary" :color-lightness="$root.colors.bgColorLightness" :actions-align="actionsAlign" :actions-divider="actionsDivider" :schema="schema" :dense="dense" @submit="onSubmit" @reset="onReset">
          <template v-slot:actions>
            <divider />
            <card-actions>
              <btn plain size="sm" type="reset" :color="$root.colors.primary" :color-lightness="$root.colors.bgColorLightness" :title="$lang.reset">{{ $lang.reset }}</btn>
              <btn size="sm" type="submit" :bg-color="$root.colors.primary" :bg-color-lightness="$root.colors.bgColorLightness" color="white" :title="$lang.submit">{{ $lang.submit }}</btn>
            </card-actions>
          </template>
        </form-schema>
      </flex-col>
    </flex>
  </container>
</template>
<script>
import methods from '../../mixins/methods'

export default {
  name: 'PageFormSchema',
  mixins: [
    methods
  ],
  data () {
    return {
      schema: {},
      dense: false,
      actionsAlign: 'right',
      actionsDivider: true,
      rounded: true,
      validators: {
        empty (value) {
          return !(value.match(/^\s*$/g))
        },
        length (value) {
          return value.length
        },
        isNotNull (value) {
          console.log(value)
          return value !== 0
        },
        boolean (value) {
          return value === true
        },
        email (value) {
          return (value.match(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/))
        }
      }
    }
  },
  mounted () {
    this.getExternalData('form-schema.json', 'schema')
  },
  methods: {
    onSubmit ($event) {
      this.log('submit', 'form-schema', $event)
      this.$http({
        url: $event.action,
        method: $event.method,
        data: $event.data
      }).then(response => {
        console.log(response.data)
      }).catch(error => {
        console.error(error)
      })
    },
    onReset () {
      this.log('reset', 'form-schema')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/forms/form-schema.vue